import { render, staticRenderFns } from "./dialogFamVideo.vue?vue&type=template&id=38693698&scoped=true"
import script from "./dialogFamVideo.vue?vue&type=script&lang=js"
export * from "./dialogFamVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38693698",
  null
  
)

export default component.exports